var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3",attrs:{"role":"alert"}},[_vm._v("\n\n  "+_vm._s(_vm.message)+"\n\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }